import React from 'react';
import { Box, Container, Grid, Paper } from '@material-ui/core';
import { AppDetailsItemHeader } from './AppDetailsItemHeader';
import { IAppDetailsView } from '../AppDetailsView';
import {
    getAppOverviewPriceType,
    getDisplayPrice,
} from '../../../../components/AppCard/AppStoreUtils';

export const AppDetailsPricingPlan = ({ listing }: IAppDetailsView) => (
    <Box>
        <Container>
            <Box p={4}>
                <AppDetailsItemHeader header={'Pricing plan'} />
                <Box py={2}>
                    <Grid container spacing={4}>
                        {Array.from(listing?.pricePlans ?? []).map((plan, i) => (
                            <Grid xs item key={i}>
                                <Paper elevation={3}>
                                    <Box px={4} py={4}>
                                        <Box my={1} fontSize={'22px'} fontWeight={'900'}>
                                            {plan.name}
                                        </Box>
                                        <Box my={1}>
                                            <Box
                                                fontSize={'18px'}
                                                display={'flex'}
                                                alignItems={'center'}
                                            >
                                                {getDisplayPrice(plan.plan)}
                                            </Box>
                                        </Box>
                                        {plan.features && (
                                            <Box
                                                dangerouslySetInnerHTML={{
                                                    __html: plan.features?.replaceAll(
                                                        '\n',
                                                        '<br />'
                                                    ),
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
                <Box
                    py={2}
                    textAlign={'center'}
                    color={'rgba(87, 100, 111, 0.78)'}
                    fontSize={'14px'}
                >
                    All charges are billed in USD. Recurring charges are billed every month and may
                    include additional fees (taxes, setup fees and more).
                </Box>
            </Box>
        </Container>
    </Box>
);
